/* About page — story band video.
   Shows a single play button over the poster; native controls appear once playing.
   Without this script the video keeps its native controls, so it always plays. */
(() => {
  if (window.abStoryLoaded) return;
  window.abStoryLoaded = true;

  const init = (scope) => {
    scope.querySelectorAll('[data-ab-video]').forEach((wrapper) => {
      if (wrapper.dataset.abReady) return;
      const video = wrapper.querySelector('video');
      const button = wrapper.querySelector('[data-ab-play]');
      if (!video || !button) return;
      wrapper.dataset.abReady = 'true';

      video.removeAttribute('controls');
      button.hidden = false;
      button.addEventListener('click', () => {
        video.setAttribute('controls', '');
        video.setAttribute('tabindex', '-1');
        button.hidden = true;
        video.focus();
        const playing = video.play();
        if (playing && playing.catch) playing.catch(() => {});
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
